import { Button, Flex, Group, Select, Text } from '@byecode/ui'
import { findWechatPaymentAccount, isWechatPaymentAccountAvailable, useAtomData, wechatPaymentAccountLabel } from '@lighthouse/shared'
import React from 'react'

import { otherPlatformListAtom } from '@/atoms/application/state'
import { openOtherPlatform } from '@/containers/OtherPlatforms/OtherPlatformEvent'
import { useIsDisabledWithVersion } from '@/hooks/useIsDisabledWithVersion'

type Props = {
    value?: string
    onChange: (accountId: string) => void
    requireEnabled?: boolean
}

export const WechatPaymentAccountSelect: React.FC<Props> = ({ value, onChange, requireEnabled = false }) => {
    const accounts = useAtomData(otherPlatformListAtom)
    const disabled = useIsDisabledWithVersion()
    const account = findWechatPaymentAccount(accounts, value)
    const options = (accounts ?? [])
        .filter(item => item.type === 'WECHAT_PAY')
        .map(item => ({
            value: item.id,
            label: `${wechatPaymentAccountLabel(item.config)}${item.config?.enabled === false ? '（已停止新收款）' : ''}`,
            disable: !isWechatPaymentAccountAvailable(item, requireEnabled)
        }))
    if (value && !account) {
        options.push({ value, label: '原商户不可用，请重新选择', disable: true })
    }
    const error =
        value && !isWechatPaymentAccountAvailable(account, requireEnabled)
            ? '所选商户未完成配置、已不可用或不允许执行此操作'
            : undefined

    return (
        <Group label="授权配置">
            <Flex direction="column" gap={8} style={{ padding: '8px 16px' }}>
                <Flex alignItems="center" justifyContent="space-between">
                    <Text>收款商户</Text>
                    <Button size="xs" disabled={disabled} onClick={() => openOtherPlatform({ type: 'WECHAT_PAY' })}>
                        管理商户
                    </Button>
                </Flex>
                <Select
                    value={value ?? ''}
                    options={options}
                    onChange={onChange}
                    disabled={disabled}
                    searchable
                    placeholder="不选则使用最早的有效商户"
                    notFound="暂无可用商户，请先管理商户配置"
                />
                {error && (
                    <Text size={12} color="var(--color-red-500)">
                        {error}
                    </Text>
                )}
                <Text size={12} color="var(--color-gray-500)">
                    {requireEnabled
                        ? '未选择时使用创建时间最早、且仍允许新收款的商户。'
                        : '未选择时按原支付商户处理；如果选择，必须与原交易商户一致。'}
                </Text>
            </Flex>
        </Group>
    )
}
